// import { faBars, faChevronDown, faChevronLeft, faTimes } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { routes, SidebarRoute } from "configs/SidebarConfig";
// import { FC, useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
// import { Link, NavLink, useLocation } from "react-router-dom";
// import useSidebarStore from "store/useSidebarStore";
// import { useThemeStore } from "store/useThemeStore";
// import useTailwindBreakpoints from "utils/useTailwindBreakPoints";
// import ThemeToggle from "./ThemeToggle";
// import { routeVariables } from "routes/routeVariables";
// import { useAuthStore } from "store/useAuthStore";
// import { checkPermission } from "utils/checkPermissions";

// const Sidebar: FC = () => {
//   const { isOpen, toggleSidebar, closeSidebar } = useSidebarStore();
//   const { t } = useTranslation();
//   const { theme } = useThemeStore();
//   const [openDropdown, setOpenDropdown] = useState<string | null>(null);
//   const currentRoute = useLocation();
//   const { isMd } = useTailwindBreakpoints();
//   const { isAuthenticated, profile } = useAuthStore();

//   const parentPath = currentRoute.pathname.split("/").slice(0, 2).join("/");

//   const handleDropdownClick = (route: SidebarRoute) => {
//     setOpenDropdown(openDropdown === route.title ? null : route.title);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 768) {
//         closeSidebar();
//       }
//     };

//     handleResize(); // Check on mount
//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);
//   }, [closeSidebar]);

//   const renderRoutes = (routes: SidebarRoute[]) => {
//     return routes.map((route, index) => {
//       if (route.notShowInSidebar) {
//         return null;
//       }
//       return (
//         <li key={index} className="mb-2">
//           {route.path ? (
//             checkPermission(profile, route.permissions || []) && (
//               <NavLink
//                 to={route.path}
//                 onClick={isMd ? toggleSidebar : () => false}
//                 className={({ isActive }) => `${isActive ? "text-primary flex items-center active" : "text-text flex items-center"} hover:text-hoverPrimary mt-4 transition300 parent-animation-on-hover`}
//               >
//                 {route.icon && <FontAwesomeIcon icon={route.icon} className="mr-2 shake-on-hover" />}
//                 <span className={`ml-2 ${isOpen ? "block" : "hidden"}`}>{t(route.title)}</span>
//               </NavLink>
//             )
//           ) : (
//             <>
//               <div className={`${parentPath === "/" + route.title.toLowerCase() ? "text-primary" : "text-text"} flex items-center cursor-pointer hover:text-hoverPrimary transition300`} onClick={() => handleDropdownClick(route)}>
//                 {route.icon && <FontAwesomeIcon icon={route.icon} className="mr-2 shake-on-hover" />}
//                 <span className={`ml-2 mr-auto ${isOpen ? "block" : "hidden"}`}>{t(route.title)}</span>
//                 {isOpen && <FontAwesomeIcon icon={openDropdown === route.title || parentPath === "/" + route.title.toLowerCase() ? faChevronLeft : faChevronDown} size="xs" />}
//               </div>
//               {route.subRoutes && <ul className={`ml-9 mt-2 ${openDropdown === route.title || parentPath === "/" + route.title.toLowerCase() ? "block" : "hidden"}`}>{renderRoutes(route.subRoutes)}</ul>}
//             </>
//           )}
//         </li>
//       );
//     });
//   };

//   return (
//     <>
//       <div className={`fixed -top-3 left-0 md:bg-sidebar p-4 transition-all duration-300 z-40 ${isOpen ? "md:w-64 w-fit" : "w-fit"}`}>
//         <div className={`flex justify-between items-center mt-4`}>
//           {isOpen && (
//             <Link to={routeVariables.main}>
//               <div className="md:w-32 hidden md:block object-contain mt-2">
//                 <img className={`md:w-full hidden md:block object-contain`} src={`${theme === "dark" ? "/images/newLogo.png" : "/images/newLogo-black.png"}`} />
//               </div>
//             </Link>
//           )}
//           <button onClick={toggleSidebar} className={`text-text mb-4 absolute top-8 ${isOpen ? "md:right-4" : "md:left-4"}`} type="button">
//             <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
//           </button>
//         </div>
//       </div>
//       <div className={`fixed top-[3.7rem] left-0 h-heightMobileSidebar bg-sidebar p-4 transition-all duration-300 z-30 ${isOpen ? "md:w-64 w-[50%} translate-x-0" : "md:w-16 md:translate-x-0 w-0 -translate-x-[200%]"}`}>
//         <nav className={`flex flex-col items-start mt-5 overflow-y-auto h-[80%] ${isOpen ? "" : "-mr-4"}`}>
//           <ul className="flex flex-col gap-4 w-full">{renderRoutes(routes)}</ul>
//         </nav>
//         <div className={`${isOpen ? "md:left-20 left-7" : "left-[15px]"} fixed bottom-8 z-30`}>
//           <ThemeToggle />
//         </div>
//       </div>
//     </>
//   );
// };

// export default Sidebar;
import {
  faBars,
  faChevronDown,
  faChevronLeft,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { routes, SidebarRoute } from "configs/SidebarConfig";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useLocation } from "react-router-dom";
import useSidebarStore from "store/useSidebarStore";
import { useThemeStore } from "store/useThemeStore";
import ThemeToggle from "./ThemeToggle";
import { routeVariables } from "routes/routeVariables";
import { useAuthStore } from "store/useAuthStore";
import { checkPermission } from "utils/checkPermissions";
import useTailwindBreakpoints from "utils/useTailwindBreakPoints";

const Sidebar: FC = () => {
  const { isOpen, toggleSidebar, closeSidebar } = useSidebarStore();
  const { t } = useTranslation();
  const { theme } = useThemeStore();
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const currentRoute = useLocation();
  const { isMd } = useTailwindBreakpoints();
  const { isAuthenticated, profile } = useAuthStore();

  // Auto-detect active parent route
  useEffect(() => {
    const findActiveParent = (
      routes: SidebarRoute[],
      path: string
    ): string | null => {
      for (const route of routes) {
        if (route.subRoutes) {
          // Check if current path matches any subroute
          const hasActiveChild = route.subRoutes.some(
            (subRoute) => subRoute.path && path.startsWith(subRoute.path)
          );

          if (hasActiveChild) return route.title;

          // Check nested subroutes
          const nestedParent = findActiveParent(route.subRoutes, path);
          if (nestedParent) return route.title;
        }
      }
      return null;
    };

    const activeParent = findActiveParent(routes, currentRoute.pathname);
    if (activeParent) {
      setOpenDropdown(activeParent);
    }
  }, [currentRoute.pathname]);

  const handleDropdownClick = (route: SidebarRoute) => {
    setOpenDropdown((prev) => (prev === route.title ? null : route.title));
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        closeSidebar();
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [closeSidebar]);

  const renderRoutes = (routes: SidebarRoute[]) => {
    return routes.map((route, index) => {
      if (route.notShowInSidebar) {
        return null;
      }

      const isActiveParent = route.subRoutes?.some(
        (subRoute) =>
          subRoute.path && currentRoute.pathname.startsWith(subRoute.path)
      );

      return (
        <li key={index} className="mb-2">
          {route.path ? (
            true && (
              <NavLink
                to={route.path}
                onClick={isMd ? toggleSidebar : () => false}
                className={({ isActive }) => `
                  ${
                    isActive
                      ? "text-primary flex items-center active"
                      : "text-text flex items-center"
                  } 
                  hover:text-hoverPrimary mt-4 transition-all duration-300 ease-in-out
                `}
              >
                {route.icon && (
                  <FontAwesomeIcon
                    icon={route.icon}
                    className="mr-2 transition-transform duration-300"
                    title={route.title}
                  />
                )}
                <span
                  className={`ml-2 ${
                    isOpen ? "opacity-100 block" : "opacity-0 hidden"
                  } transition-opacity duration-300`}
                >
                  {t(route.title)}
                </span>
              </NavLink>
            )
          ) : (
            <>
              <div
                className={`
                  ${isActiveParent ? "text-primary" : "text-text"} 
                  flex items-center cursor-pointer hover:text-hoverPrimary 
                  mt-4 transition-all duration-300 ease-in-out
                `}
                onClick={() => handleDropdownClick(route)}
              >
                {route.icon && (
                  <FontAwesomeIcon
                    icon={route.icon}
                    className="mr-2 transition-transform duration-300"
                    title={t(route.title)}
                  />
                )}
                <span
                  className={`ml-2 mr-auto ${
                    isOpen ? "opacity-100 block" : "opacity-0 hidden"
                  } transition-opacity duration-300`}
                >
                  {t(route.title)}
                </span>
                {isOpen && (
                  <FontAwesomeIcon
                    icon={
                      openDropdown === route.title || isActiveParent
                        ? faChevronLeft
                        : faChevronDown
                    }
                    size="xs"
                    className="transition-transform duration-500"
                  />
                )}
              </div>
              {route.subRoutes && (
                <div
                  className={`
                  overflow-hidden
                  ${
                    openDropdown === route.title || isActiveParent
                      ? "max-h-screen"
                      : "max-h-0"
                  }
                  transition-all duration-500 ease-in-out
                `}
                >
                  <ul className="ml-1 mt-2 pl-4 border-l border-text">
                    {renderRoutes(route.subRoutes)}
                  </ul>
                </div>
              )}
            </>
          )}
        </li>
      );
    });
  };

  return (
    <>
      <div
        className={`fixed -top-3 left-0 md:bg-sidebar p-4 transition-all duration-300 z-40 ${
          isOpen ? "md:w-64 w-fit" : "w-fit"
        }`}
      >
        <div className={`flex justify-between items-center mt-4`}>
          {isOpen && (
            <Link to={routeVariables.main}>
              <div className="md:w-32 hidden md:flex object-contain mt-2 items-center gap-3">
                <img
                  className={`md:w-10 hidden md:block object-contain`}
                  src={`${
                    theme === "dark" ? "/images/black.png" : "/images/black.png"
                  }`}
                />
                <h1 className="text-2xl text-text">Domaxit</h1>
              </div>
            </Link>
          )}
          <button
            onClick={toggleSidebar}
            className={`text-text mb-4 absolute top-8 ${
              isOpen ? "md:right-4" : "md:left-4"
            }`}
            type="button"
          >
            <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
          </button>
        </div>
      </div>
      <div
        className={`fixed top-[3.7rem] left-0 h-heightMobileSidebar bg-sidebar p-4 transition-all duration-300 z-30 ${
          isOpen
            ? "md:w-64 w-[50%} translate-x-0"
            : "md:w-16 md:translate-x-0 w-0 -translate-x-[200%]"
        }`}
      >
        <nav
          className={`flex flex-col items-start mt-5 overflow-y-auto h-[80%] ${
            isOpen ? "" : "-mr-4"
          }`}
        >
          <ul className="flex flex-col gap-4 w-full">{renderRoutes(routes)}</ul>
        </nav>
        <div
          className={`${
            isOpen ? "md:left-20 left-7" : "left-[15px]"
          } fixed bottom-8 z-30`}
        >
          <ThemeToggle />
        </div>
      </div>
    </>
  );
};

export default Sidebar;
